import { Components } from "appworks/components/components";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { BitmapText } from "appworks/graphics/pixi/bitmap-text";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { slotModel } from "slotworks/model/slot-model";
import { AbstractTextControl } from "./abstract-text-control";

export class AutoCountTextControl extends AbstractTextControl {
    constructor(label: FlexiText | BitmapText) {
        super(label);

        Components.get(AbstractMatrixComponent).startSignal.add(this.updateCount);
        this.updateCount();
    }

    public destroy(): void {
        Components.get(AbstractMatrixComponent).startSignal.remove(this.updateCount);
    }

    protected updateCount = () => {
        const value = slotModel.read().autoplay.autoplays.currentValue;
        this.text.setText((value === Infinity) ? Services.get(TranslationsService).getFirstValid(["infinity", "aut.inf"]) : value.toString());
    }
}
